import { api, auth } from '@/f1/service';
import Language from './language';
import moment from 'moment-timezone';
import WMDSSiteList from '../../WMDS/result/Site.List.i18n';
import codes from '@/f1/codes';
import { extendMoment } from 'moment-range';
import { VclFacebook } from 'vue-content-loading';
import lineChart from '../../report/chart/MainChart';
import Trend from "vuetrend"
import _ from 'lodash'

const default_moment = extendMoment(require('moment'));

export default {
  components : {
    Trend,
    VclFacebook,
    WMDSSiteList,
    Language,
    lineChart
  },
  data: () => {
    return {
      chart : {
        page : [],
        detect : [],
        error : [],
      },

      loading : false,
      codes,
      pattern : {},
      auth,
      th : undefined,
      agents : [],
      count : 0,
      info : { day : 0, week : 0, month : 0, module : { alive : 0, deleted : 0} }
    }
  },
  // computed : { chartData() { return this.chartOptions; } },
  methods: {
    value_comma(v) {
      return (v.toFixed(0) || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    default_info() { return { page_count : 0, detect_count : 0, error_count : 0, total : 0 } },
    catch_msg(e) { console.error(e); this.$toastr.e(e.data ? e.data.message : e.statusText); },
    load() {

      try {
        api.wmds.WMDS_Call("dashboard", "week").then(rs => {
          let today = moment();
          let start = moment().add(-7, 'days')

          console.log('start', start.format('YYYY-MM-DD'), 'today', today.format('YYYY-MM-DD'))

          let range = default_moment.range(start, today);
          let days = range.by('days');
          const search_range = [...days].map(date => date.format('YYYY-MM-DD'))
          // console.log('search_range', search_range)

          this.chart.detect  = [] // = JSON.parse(JSON.stringify(format))
          this.chart.error  = [] // =  JSON.parse(JSON.stringify(format))
          this.chart.page  = [] // = JSON.parse(JSON.stringify(format))


          for (let i = 0; i < search_range.length; i++) {

            this.chart.detect.push(0)
            this.chart.error.push(0)
            this.chart.page.push(0)

          }

          console.log(rs.body.data)


          for (let i = 0; i < rs.body.data.length; i++) {
            const r = rs.body.data[i];
            let rdate = moment(r.date);
            console.log(rdate, r)

            if(r.date == moment().format('YYYY-MM-DD')) {
              this.info.day = {
                page_count : r.page_count,
                detect_count : r.detect_count,
                error_count : r.error_count,
              }
            }

            let index = search_range.indexOf(r.date)
            if(index < 0) { continue }

            this.chart.detect[index] = r.detect_count
            this.chart.error[index] = r.error_count
            this.chart.page[index] = r.page_count
          }

        }).catch(e => this.catch_msg(e));

        api.wmds.WMDS_Call("dashboard", "agent").then(rs => {
          this.info.module = { alive : 0, deleted : 0 };
          if(rs.is_error) { return this.$toastr.e("load failed") }
          this.info.module.alive = rs.body.data.total - rs.body.data.deleted
          this.info.module.deleted = rs.body.data.deleted

        }).catch(e => this.catch_msg(e));

        _.forEach(this.$refs, x => { try { console.log(x._uid, 'start') && x && x.play && x.indexOf('_check_') > -1 && x.play() } catch (e) { console.log(e); }})

      } catch (e) { console.error(e) }
    },
    get_pattern() {
      this.loading = true
        let so = {
          target : 'pattern', cmd : 'latest',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
          offset : 0, limit: 1,
        }

      return api.wmds.WMDS(so)
        .then(rs => { this.loading = false; this.pattern = rs.body;  })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))

    },
  },
  async mounted () {
    console.log('dashboard.vue mounted');
    this.load();
    this.get_pattern()
  },
  destroyed () {
    console.log('dashboard.vue destroyed');
  },
  watch : {
    '$route' (to, from) {
      // this.load(to.params.id, from);
    }
  }
}
